"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResetTutorialPopoversButton = exports.TutorialPopover = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var Block_1 = require("./Block");

var flags_1 = require("./flags"); // This flag is here to make sure we only render one of these on the page, every time
// the page is refreshed. That way the teacher isn't inundated with these popovers.


var didEmbedKeys = []; // This is to make sure only one popover automatically shows at the same time on the page.

var visiblePopoverKey = null;
var keyTimeout = null;
var resetCallbacks = [];
var resetFlags = new Set();

function performResetCallbacks() {
  didEmbedKeys = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = resetFlags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var flag = _step.value;
      (0, flags_1.setFlag)(flag, null);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  resetFlags.clear();
  visiblePopoverKey = null;
  keyTimeout = null;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = resetCallbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var callback = _step2.value;
      callback();
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
        _iterator2["return"]();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function TutorialPopover(_a) {
  var autoShow = _a.autoShow,
      children = _a.children,
      tutorialKey = _a.tutorialKey,
      content = _a.content,
      rest = __rest(_a, ["autoShow", "children", "tutorialKey", "content"]);

  var _react_1$default$useS = react_1["default"].useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      shouldEmbed = _react_1$default$useS2[0],
      setShouldEmbed = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1["default"].useState(true),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      visible = _react_1$default$useS4[0],
      setVisible = _react_1$default$useS4[1];

  react_1["default"].useEffect(function () {
    if (visible) {
      clearTimeout(keyTimeout);
      keyTimeout = setTimeout(function () {
        visiblePopoverKey = tutorialKey;
      }, 100);
    } else if (visiblePopoverKey === tutorialKey) {
      visiblePopoverKey = null;
    }
  }, [visible, tutorialKey]);
  react_1["default"].useEffect(function () {
    if (!visible) {
      var cancel = setTimeout(function () {
        setShouldEmbed(false);
      }, 500);
      return function () {
        return clearTimeout(cancel);
      };
    }
  }, [visible]);
  react_1["default"].useEffect(function () {
    var callback = function callback() {
      if (autoShow && !didEmbedKeys.includes(tutorialKey) && !(0, flags_1.getFlag)(tutorialKey)) {
        if (!visiblePopoverKey) {
          didEmbedKeys.push(tutorialKey);
          setShouldEmbed(true);
          setVisible(true);
        } else {
          console.warn('Not showing TutorialPopover with key "%s" - we\'re already showing another one with autoShow enabled ("%s").', tutorialKey, visiblePopoverKey);
        }
      }
    };

    resetFlags.add(tutorialKey);
    resetCallbacks.push(callback);
    callback();
    return function () {
      var index = resetCallbacks.indexOf(callback);
      resetCallbacks = resetCallbacks.splice(index, 1);
    };
  }, [autoShow]);

  if (shouldEmbed) {
    return react_1["default"].createElement(antd_1.Popover, Object.assign({
      placement: 'left',
      trigger: ['click'],
      overlayStyle: {
        width: 300
      }
    }, rest, {
      visible: visible,
      onVisibleChange: setVisible,
      content: react_1["default"].createElement(react_1["default"].Fragment, null, content, react_1["default"].createElement(Block_1.HSpaced, {
        justify: 'flex-end'
      }, react_1["default"].createElement(antd_1.Button, {
        type: 'link',
        size: 'small',
        onClick: function onClick() {
          (0, flags_1.setFlag)(tutorialKey, true);
          setVisible(false);
        }
      }, "Don't show again"), react_1["default"].createElement(antd_1.Button, {
        size: 'small',
        onClick: function onClick() {
          setVisible(false);
        }
      }, "Close")))
    }), children);
  } else {
    return react_1["default"].createElement("span", {
      onMouseEnter: autoShow ? undefined : function () {
        var willEmbed = !didEmbedKeys.includes(tutorialKey) && !(0, flags_1.getFlag)(tutorialKey) && !visiblePopoverKey;

        if (willEmbed) {
          didEmbedKeys.push(tutorialKey);
          setShouldEmbed(true);
          setVisible(true);
        }
      }
    }, children);
  }
}

exports.TutorialPopover = TutorialPopover;

function ResetTutorialPopoversButton(props) {
  return react_1["default"].createElement(antd_1.Button, Object.assign({
    icon: react_1["default"].createElement(icons_1.QuestionCircleOutlined, null),
    type: 'link'
  }, props, {
    onClick: function onClick() {
      performResetCallbacks();
    }
  }));
}

exports.ResetTutorialPopoversButton = ResetTutorialPopoversButton;